export default __webpack_public_path__ + "static/media/download.d398a7b8.svg";